import { extend } from 'sk-ui/lib/utils/util.js'

import limitForm from './metaData/limitForm'

import { doLike, doDislike } from '@/api/limit'
export default {
  LimitCreate({ commit }, params) {
    let specId = params.viewController.viewMetaData.params?.specId
    let featureName = params.viewController.viewMetaData.extraParams?.featureName
    const props = {
      params: {
        specId: specId
      }
    }
    const createForm = extend(true, {}, limitForm)
    createForm.view.title = '添加功能【' + featureName + '】限制说明'
    createForm.needFetchFillInfo = false
    this.dispatch('OpenFullDialog', {
      metaData: createForm,
      props
    })
  },
  LimitEdit({ commit }, params) {
    let specId = params.viewController.viewMetaData.params?.specId
    let featureName = params.viewController.viewMetaData.extraParams?.featureName
    const props = {
      params: {
        specId: specId,
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, limitForm)
    editForm.needFetchFillInfo = true
    editForm.view.title = '修改功能【' + featureName + '】限制说明'
    this.dispatch('OpenFullDialog', {
      metaData: editForm,
      props,
      clone: false
    })
  },
  LimitDoLike({ commit }, params) {
    return doLike({ id: params.rowId })
      .then(response => {
        params.viewController.fetch()
        this.dispatch('OpenNotification', { message: '操作成功', type: 'success' })
      })
      .catch(e => {
        throw e
      })
  },
  LimitDoDislike({ commit }, params) {
    return doDislike({ id: params.rowId })
      .then(response => {
        params.viewController.fetch()
        this.dispatch('OpenNotification', { message: '操作成功', type: 'success' })
      })
      .catch(e => {
        throw e
      })
  }
}
